<template>
  <v-container fluid class="pa-0">
    <img
      src="@/assets/banner_privacy_policy.webp"
      class="banner"
      width="100%"
      alt="Imagem do Hospital da Cassems em Campo Grande, Mato Grosso do Sul"
    >

    <v-row class="py-8">
      <v-col cols="10" class="mx-auto">
        <h1 class="my-3 text-primary font-weight-bold">
          Política Interna de Proteção de Dados Pessoais
        </h1>

        <h3 class="mb-4 text-subtitle">
          A Política Interna de Privacidade e Proteção de Dados da CASSEMS
          estabelece diretrizes para o tratamento seguro e ético de dados
          pessoais por todos os colaboradores e terceiros que atuam em nome da
          empresa, independentemente de vínculo direto ou da natureza do
          tratamento.
        </h3>

        <p class="text-justify mb-4">
          A Caixa de Assistência dos Servidores do Estado de Mato Grosso do Sul
          (CASSEMS) possui forte compromisso com a privacidade e a proteção dos
          dados pessoais e, constantemente, revê e adequa seus processos e
          controles internos, de forma a se alinhar e atender às exigências da
          Lei Geral de Proteção de Dados (LGPD) e demais regulamentos e normas
          vigentes.
        </p>

        <p class="text-justify mb-4">
          A CASSEMS adota uma postura de total transparência em suas operações,
          garantindo que todos os processos de coleta, armazenamento e uso de
          dados pessoais sejam claros e acessíveis aos titulares dos dados.
        </p>

        <p class="text-justify mb-4">
          A transparência, a ética e as práticas em segurança das informações
          são os pilares fundamentais de nossa abordagem para a gestão da
          privacidade e da proteção de dados pessoais. Esta Política se firma
          como alicerce para todas as práticas e processos internos da CASSEMS
          relativos à coleta e ao tratamento de dados pessoais.
        </p>

        <a
          class="download-btn"
          href="https://cassems-imagem-replica.s3.us-east-2.amazonaws.com/634-P001-PIPD.pdf"
          target="_blank"
          rel="noopener noreferrer" 
        >
          <v-icon class="download-icon">
            mdi-file-document-outline
          </v-icon>
          <span
            class="download-text"
          >Download da Política Interna de Privacidade (PDF)</span>
        </a>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "PrivacyPolicy",
};
</script>

<style scoped>
.banner {
  width: 100%;
  height: auto;
  max-height: 400px;
  object-fit: cover;
  object-position: center;
  display: block;
}

.text-primary {
  color: #173c94;
}

.text-subtitle {
  font-weight: 400;
  color: #444;
}

.download-btn {
  text-decoration: none;
  display: inline-flex;
  background-color: #173c94 !important;
  color: white !important;
  font-weight: bold;
  padding: 14px 24px;
  border-radius: 10px;
  border: 2px solid transparent;
  transition: all 0.3s ease;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
  margin-top: 20px;
}

.download-btn:hover {
  background-color: white !important;
  color: #173c94 !important;
  border-color: #173c94;
  transform: translateY(-4px);
  box-shadow: 0 6px 14px rgba(0, 0, 0, 0.25);
}

.download-icon {
  color: white !important;
  font-size: 26px;
  margin-right: 8px;
  transition: color 0.3s ease;
}

.download-btn:hover .download-icon {
  color: #173c94 !important;
}

.download-text {
  font-size: 1.05rem;
  transition: color 0.3s ease;
}
</style>
